import { isoZ, z } from 'my-zod'
import { cardModel } from './payment-method-model'
import { stripeChargeRiskLevel } from '../transfers'
import { disputeStatusOptions } from '../customer-order-disputes'

export const orderCardModel = cardModel.augment({
  balance: z.number(),
  authorizations: z.object({ id: z.string(), amount: z.number() }).array(),
  actions: z.enum(['charge', 'refund']).array(),
  risk: z
    .object({
      riskScore: z.number(),
      riskLevel: stripeChargeRiskLevel
    })
    .nullable(),
  charges: z.array(
    z.object({
      brand: cardModel.shape.brand,
      createdDate: isoZ.instant(),
      amount: z.number(),
      last4: z.string().nullable(),
      risk: z
        .object({
          riskScore: z.number(),
          riskLevel: stripeChargeRiskLevel
        })
        .nullable(),
      disputes: z
        .object({
          id: z.string(),
          shortId: z.string(),
          amount: z.number(),
          status: z.enum(disputeStatusOptions),
          disputedChargeId: z.string()
        })
        .array()
        .nullable()
    })
  )
})

export type orderCardModel = z.infer<typeof orderCardModel>
